import React, { PropTypes } from 'react';
import RateSetInfo from './1-rate-set-info';
import RatesAccom from './2-rates';
import RatesNonAccom from './2-non-accom-rates';
import ReviewAdd from './3-review-add';
import AddSeasonDates from './4-season-dates';

const AddRate3Steps = props => {
  const {
    index,
    fieldValues,
    updateFieldValue,
    updateFieldWithKeyPath,
    updateDaysOfWeek,
    updateRatesTableCell,
    calculateRatesTable,
    calculateStandardNonAccomRateTable,
    goToNextStep,
    goToPreviousStep,
    updateFormData,

    productName,
    cancelText,
    onFinish,
    cancelFunc,
    step3ContinueText,
    productType,
    usedRateSetNamesAndCodes, // this will only be passed down when user click + add another rate set to **

    seasonInfo,
    addDateRanges,
    existingSeasons,
    selectExistingSeason,
    updateSeasonWizardWithKeyPath,
    saveProductInfoChanges,
    contractingPeriod,
    removeRateSetFromSeasonWhenGoBack,
    getOverlappingDaysError,
    } = props;
  const RatesForm = productType === 'Non-Accommodation' ? RatesNonAccom : RatesAccom;
  const sharedProps = {
    ...fieldValues,
    updateFieldValue,
    updateFieldWithKeyPath,
    updateDaysOfWeek,
    goToNextStep,
    goToPreviousStep,
    cancelFunc,
    cancelText,
  };
  const propsForRateSetInfo = {
    componentIndex: 0,
    productName,
    productType,
    usedRateSetNamesAndCodes,
    getOverlappingDaysError,
    ...sharedProps,
  };
  const propsForRates = {
    componentIndex: 1,
    calculateRatesTable,
    calculateStandardNonAccomRateTable,
    updateFormData,
    ...sharedProps,
  };
  const propsForReviewAdd = {
    componentIndex: 2,
    updateRatesTableCell,
    step3ContinueText,
    onFinish,
    cancelFunc,
    cancelText,
    productType,
    ...sharedProps,
  };
  const propsForAddSeasonDates = {
    componentIndex: 3,
    updateFieldValue,
    seasonInfo,
    addDateRanges,
    existingSeasons: existingSeasons || [],
    selectExistingSeason,
    cancelText,
    cancelFunc,
    saveProductInfoChanges,
    continueText: 'Save',
    contractingPeriod,
    updateSeasonWizardWithKeyPath,
    backFunc: removeRateSetFromSeasonWhenGoBack,
  };
  if (index === 0) return <RateSetInfo key="RateSetInfo" {...propsForRateSetInfo} />;
  if (index === 1) return <RatesForm key="Rates" {...propsForRates} />;
  if (index === 2) return <ReviewAdd key="ReviewAdd" {...propsForReviewAdd} />;
  if (index === 3) return <AddSeasonDates {...propsForAddSeasonDates} />;
};

AddRate3Steps.propTypes = {
  index: PropTypes.number,
  fieldValues: PropTypes.object,
  updateFieldValue: PropTypes.func,
  updateDaysOfWeek: PropTypes.func,
  updateRatesTableCell: PropTypes.func,
  calculateRatesTable: PropTypes.func,
  goToPreviousStep: PropTypes.func,
  goToNextStep: PropTypes.func,
  onFinish: PropTypes.func,
  cancelFunc: PropTypes.func,
  showStepOneBack: PropTypes.bool,
  stepOneBackFunc: PropTypes.func,
  step3ContinueText: PropTypes.string,
  cancelText: PropTypes.string,
  productType: PropTypes.string,
  usedRateSetNamesAndCodes: PropTypes.array,
};


export default AddRate3Steps;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/add-rates-wizard/all-four-steps-dumb.jsx